// Shared types for observability and correlation
export interface CorrelationIDs {
  correlationId: string;
  sessionId: string;
  userId?: string;
  organizationId?: string;
}

export interface CorrelationContext {
  correlationId: string;
  sessionId: string;
  refreshCorrelationId: () => void;
  refreshSessionId: () => void;
  updateUserContext: (userId?: string, organizationId?: string) => void;
  getCorrelationIds: () => CorrelationIDs;
}

export interface EnhancedLogData {
  correlationId: string;
  sessionId: string;
  userId?: string;
  organizationId?: string;
  timestamp: Date;
  environment: string;
  userAgent?: string;
}

// Headers for API correlation
export const CORRELATION_HEADERS = {
  CORRELATION_ID: "X-Correlation-Id",
  SESSION_ID: "X-Session-Id",
  USER_ID: "X-User-Id",
  ORGANIZATION_ID: "X-Organization-Id",
} as const;

// Storage keys for persistence
export const STORAGE_KEYS = {
  CORRELATION_ID: "app_correlation_id",
  SESSION_ID: "app_session_id",
} as const;
